import React from "react";
import useNftProposal from "../../../hooks/useNftProposal";
import NFTCard from "../../../assets/bg66.jpg";
/**
 * (Supply Component for view supply value)
 * author Khaled Mofeed
 **/
function Supply(props) {
  const { nftTotal } = useNftProposal();
  return (
    <>
      <div className="supply-img text-center">
        <img src={NFTCard} className="w-100 bg66" alt="NFTCard" />
        <h2 className="supply">{nftTotal}</h2>
        <h4 className="AiTalentNFT"> AiTellit NFT</h4>
        <h3 className="VotePower">VOTE POWER</h3>
      </div>
    </>
  );
}

export default Supply;
